import { IInputBox } from "./types";
import { IRoute } from "store/api/types";

export const sortBoxes = (a: IInputBox, b: IInputBox) => {
  if (a.order > b.order) {
    return 1;
  } else {
    return -1;
  }
};

export const possibleBoxIds = [1, 2, 3];

export const maxDstAddressesCount = 3;

export const initialBox = {
  id: 1,
  order: 1,
  address: "",
  building: "",
  foundPlaces: [],
  foundBuildings: [],
  lat: 0,
  lng: 0,
};

export const transformBoxesToRoutes = (boxes: IInputBox[]): IRoute[] => {
  return boxes.map((box) => ({
    name: box.address,
    number: box.building,
    lat: box.lat,
    lng: box.lng,
  }));
};
